/* eslint-disable */
import React, { useContext } from "react";
import { Data } from '../contexts';
import { pnlRows } from '../NAICSFocusedReport/NAICSFocusedReport';
import { parseMoney, parseMoneyNoDollar } from "../../utils";

const doctorsNAICS = ['621', '6211', '6213'];

const IndustryDoctorsPNL = (props) => {
    const { calcs } = useContext(Data)
    const ownersMetric = 'avg_fte';
    let commonSizeClass = props.pdf ? 'common-size-cell-pdf' : 'common-size-cell';
    // Need to common size with Gross Receipts
    let grossReceiptsVals = {}
    const grossReceiptsRow = {
        bold: true,
        copy: 'Gross Receipts',
        key: 'gross_receipts',
        map_keys: ['total_revenue'],
        padding: '',
    }

    const mappedTotal = (row, years, avg, key) => {
        let totalObj = {}
        totalObj['key'] = key
        years.forEach(year => {
            let compareTotalRevenue = avg['total_revenue'] ? avg['total_revenue'][year] : 0
            let compareGrossReceipts = grossReceiptsVals?.['avgVal' + year] || 0

            let avgSum = 0

            if (key === 'salaries_non_owners') {
                let compareTotalCompensation = avg?.['total_compensation'] ? avg?.['total_compensation']?.[year] : 0
                let compareSalariesDoctor = 0

                if (props.naicsCode && props.naicsCode.startsWith('6212')) {
                    compareSalariesDoctor = avg?.['dentist']?.[year] ? avg?.['dentist']?.[year] : 0
                } else if (props.naicsCode && doctorsNAICS.some(naics => props.naicsCode.startsWith(naics))) {
                    compareSalariesDoctor = avg?.['total_compensation_doctor'] ? avg?.['total_compensation_doctor']?.[year] : 0
                }

                avgSum = compareTotalCompensation - compareSalariesDoctor
            } else {
                row.map_keys.forEach((c) => {
                    avgSum += avg?.[c] ? avg?.[c]?.[year] : 0
                })
            }

            totalObj['avgVal' + year] = avgSum;
            totalObj['avg' + year] = (avgSum / compareGrossReceipts) * 100;

            if (props.report === 'nschbc-employee-data') {
                if (key === 'salaries_non_owners') {
                    if (avg?.[ownersMetric]?.[year]) {
                        let compareGrossReceipts = grossReceiptsVals?.['fteVal' + year] || 0

                        let compareTotalCompensation = avg?.['total_compensation']?.[year] ? avg['total_compensation'][year] / avg[ownersMetric][year] : 0
                        let compareSalariesDoctor = 0

                        if (props.naicsCode && props.naicsCode.startsWith('6212')) {
                            compareSalariesDoctor = avg?.['dentist']?.[year] ? avg['dentist'][year] / avg[ownersMetric][year] : 0
                        } else if (props.naicsCode && doctorsNAICS.some(naics => props.naicsCode.startsWith(naics))) {
                            compareSalariesDoctor = avg?.['total_compensation_doctor'] ? avg['total_compensation_doctor'][year] / avg[ownersMetric][year] : 0
                        }
                        totalObj['fteVal' + year] = compareTotalCompensation - compareSalariesDoctor
                        totalObj['fteAvgVal' + year] = (totalObj['fteVal' + year] / compareGrossReceipts) * 100
                    } else {
                        totalObj['fteVal' + year] = 0
                        totalObj['fteAvgVal' + year] = 0
                    }
                } else {
                    if (avg?.[ownersMetric]?.[year]) {
                        let compareGrossReceipts = grossReceiptsVals?.['fteVal' + year] || 0
                        totalObj['fteVal' + year] = totalObj['avgVal' + year] / avg[ownersMetric][year]
                        totalObj['fteAvgVal' + year] = (totalObj['fteVal' + year] / compareGrossReceipts) * 100
                    } else {
                        totalObj['fteVal' + year] = 0
                        totalObj['fteAvgVal' + year] = 0
                    }
                }
            }

        })
        return totalObj
    }

    const totalNAICSFocused = (rows, years, avg, key) => {
        let childrenObjs = rows.filter(r => r.parentKey === key)
        let totalObj = {}
        let childrenValues = []
        childrenObjs.forEach((c) => {
            childrenValues.push(mappedTotal(c, years, avg, c.key))
        })

        years.forEach(year => {
            let compareGrossReceipts = grossReceiptsVals?.['avgVal' + year] || 0
            // let compareTotalRevenue = avg['total_revenue'] ? avg['total_revenue'][year] : 0
            let avgSum = 0
            childrenValues.forEach((c) => {
                avgSum += c['avgVal' + year] ? c['avgVal' + year] : 0
            })
            totalObj['avgVal' + year] = avgSum;
            totalObj['avg' + year] = (avgSum / compareGrossReceipts) * 100;

            if (props.report === 'nschbc-employee-data') {
                if (avg?.[ownersMetric]?.[year]) {
                    let compareGrossReceipts = grossReceiptsVals?.['fteVal' + year] || 0
                    totalObj['fteVal' + year] = avgSum / avg[ownersMetric][year];
                    totalObj['fteAvgVal' + year] = (totalObj['fteVal' + year] / compareGrossReceipts) * 100;
                } else {
                    totalObj['fteVal' + year] = 0
                    totalObj['fteAvgVal' + year] = 0
                }
            }
        })
        return totalObj
    }

    const DentistDoctorPNLVals = (rows, calcs, years, row) => {
        const avg = props.report === 'nschbc-employee-data' ? calcs : calcs.docs_avg
        let rowObj = null;
        row.copyWithPadding = row.padding + row.copy
        let yearValues;

        if (avg) {
            if (row.total) {
                rowObj = totalNAICSFocused(rows, years, avg, row.key)
            } else if (row.key === 'gross_receipts') {
                rowObj = {}
                years.forEach(year => {
                    let compareGrossReceipts = grossReceiptsVals?.['avgVal' + year] || 0
                    let compareGrossCharges = avg?.['total_revenue_gross_charges']?.[year] || 0
                    let compareAdjustments = avg?.['total_revenue_adjustments']?.[year] || 0
                    rowObj['avgVal' + year] = compareGrossCharges - compareAdjustments
                    rowObj['avg' + year] = (rowObj['avgVal' + year] / compareGrossReceipts) * 100

                    if (props.report === 'nschbc-employee-data') {
                        if (calcs?.[ownersMetric]?.[year]) {
                            let compareGrossReceipts = (rowObj['avgVal' + year] || 0) / calcs[ownersMetric][year]
                            let compareGrossCharges = (avg?.['total_revenue_gross_charges']?.[year] || 0) / calcs[ownersMetric][year]
                            let compareAdjustments = (avg?.['total_revenue_adjustments']?.[year] || 0) / calcs[ownersMetric][year]
                            rowObj['fteVal' + year] = compareGrossCharges - compareAdjustments
                            rowObj['fteAvgVal' + year] = (rowObj['fteVal' + year] / compareGrossReceipts) * 100
                        } else {
                            rowObj['fteVal' + year] = 0
                            rowObj['fteAvgVal' + year] = 0
                        }
                    }
                })
            } else if (row.key === 'gross_profit') {
                rowObj = {}
                let totalDirectCosts = totalNAICSFocused(rows, years, avg, 'total_direct_costs')
                years.forEach(year => {
                    let compareGrossReceipts = grossReceiptsVals?.['avgVal' + year] || 0

                    rowObj['avgVal' + year] = compareGrossReceipts - totalDirectCosts['avgVal' + year]
                    rowObj['avg' + year] = (rowObj['avgVal' + year] / compareGrossReceipts) * 100

                    if (props.report === 'nschbc-employee-data') {
                        if (calcs?.[ownersMetric]?.[year]) {
                            let compareGrossReceipts = (grossReceiptsVals?.['fteVal' + year] || 0)
                            rowObj['fteVal' + year] = compareGrossReceipts - totalDirectCosts['fteVal' + year]
                            rowObj['fteAvgVal' + year] = (rowObj['fteVal' + year] / compareGrossReceipts) * 100
                        } else {
                            rowObj['fteVal' + year] = 0
                            rowObj['fteAvgVal' + year] = 0
                        }
                    }
                })
            } else if (row.key === 'operating_expenses_net_income') {
                rowObj = {}
                let totalDirectCosts = totalNAICSFocused(rows, years, avg, 'total_direct_costs')
                let totalAdminCosts = totalNAICSFocused(rows, years, avg, 'total_administrative_costs')
                years.forEach(year => {
                    let compareGrossReceipts = grossReceiptsVals?.['avgVal' + year] || 0

                    rowObj['avgVal' + year] = compareGrossReceipts - totalDirectCosts['avgVal' + year] - totalAdminCosts['avgVal' + year]
                    rowObj['avg' + year] = (rowObj['avgVal' + year] / compareGrossReceipts) * 100

                    if (props.report === 'nschbc-employee-data') {
                        if (calcs?.[ownersMetric]?.[year]) {
                            let compareGrossReceipts = (grossReceiptsVals?.['fteVal' + year] || 0)
                            rowObj['fteVal' + year] = compareGrossReceipts - totalDirectCosts['fteVal' + year] - totalAdminCosts['fteVal' + year]
                            rowObj['fteAvgVal' + year] = (rowObj['fteVal' + year] / compareGrossReceipts) * 100
                        } else {
                            rowObj['fteVal' + year] = 0
                            rowObj['fteAvgVal' + year] = 0
                        }
                    }
                })
            } else if (row.key === 'salaries_non_owners') {
                rowObj = {}
                years.forEach(year => {
                    let compareGrossReceipts = grossReceiptsVals?.['avgVal' + year] || 0
                    let compareTotalCompensation = avg?.['total_compensation'] ? avg?.['total_compensation']?.[year] : 0
                    let compareSalariesDoctor = 0

                    if (props.naicsCode && props.naicsCode.startsWith('6212')) {
                        compareSalariesDoctor = avg?.['dentist']?.[year] ? avg?.['dentist']?.[year] : 0
                    } else if (props.naicsCode && doctorsNAICS.some(naics => props.naicsCode.startsWith(naics))) {
                        compareSalariesDoctor = avg?.['total_compensation_doctor'] ? avg?.['total_compensation_doctor']?.[year] : 0
                    }
                    rowObj['avgVal' + year] = compareTotalCompensation - compareSalariesDoctor
                    rowObj['avg' + year] = (rowObj['avgVal' + year] / compareGrossReceipts) * 100

                    if (props.report === 'nschbc-employee-data') {
                        if (calcs?.[ownersMetric]?.[year]) {
                            let compareTotalCompensation = avg?.['total_compensation'] ? avg?.['total_compensation']?.[year] / calcs[ownersMetric][year] : 0
                            let compareGrossReceipts = (grossReceiptsVals?.['fteVal' + year] || 0)
                            let compareSalariesDoctor = 0

                            if (props.naicsCode && props.naicsCode.startsWith('6212')) {
                                compareSalariesDoctor = avg?.['dentist']?.[year] ? avg?.['dentist']?.[year] / calcs[ownersMetric][year] : 0
                            } else if (props.naicsCode && doctorsNAICS.some(naics => props.naicsCode.startsWith(naics))) {
                                compareSalariesDoctor = avg?.['total_compensation_doctor'] ? avg?.['total_compensation_doctor']?.[year] / calcs[ownersMetric][year] : 0
                            }
                            rowObj['fteVal' + year] = compareTotalCompensation - compareSalariesDoctor
                            rowObj['fteAvgVal' + year] = (rowObj['fteVal' + year] / compareGrossReceipts) * 100
                        } else {
                            rowObj['fteVal' + year] = 0
                            rowObj['fteAvgVal' + year] = 0
                        }
                    }
                })
            } else {
                if (row.key) {
                    rowObj = mappedTotal(row, years, avg, row.key)
                } else {
                    return row;
                }
            }
        }

        return rowObj;
    }

    const buildRows = () => {
        let rows = pnlRows(props.naicsCode)

        let allRows = []
        if (rows) {
            grossReceiptsVals = DentistDoctorPNLVals(rows, calcs, props.yearRange, grossReceiptsRow)
            rows.forEach((row) => {
                let rowValues = DentistDoctorPNLVals(rows, calcs, props.yearRange, row)
                allRows.push({ ...row, ...rowValues })
            })

            return allRows.map((row, i) => {

                if (row.emptyRow) {
                    return (
                        <tr>
                            <td className="industry-copy-cell"></td>
                            {props.yearRange.map((year, j) => {
                                let cellClasses = 'common-size-cell '

                                if (j % 2 === 0) {
                                    cellClasses += 'money-table-cell';
                                }
                                return (
                                    <>
                                        <td className={cellClasses}></td>
                                        <td className={cellClasses}></td>
                                        <td></td>
                                    </>
                                )
                            })}
                        </tr>
                    )
                } else {
                    let rowStyle = { ...row.style }
                    if (row.topline) {
                        rowStyle['borderTop'] = '1px solid #000000'
                    }

                    return (
                        <tr style={rowStyle}>
                            <td className="industry-copy-cell" style={{ 'fontWeight': 'bold', 'textAlign': 'left' }}>{row.copyWithPadding}</td>
                            {props.yearRange.map((year, j) => {
                                let cellClasses = 'common-size-cell '

                                if (j % 2 === 0) {
                                    cellClasses += 'money-table-cell';
                                }
                                let firstVal = row["avgVal" + year] ? parseMoney(row["avgVal" + year]) : '';
                                let secondVal = row["avg" + year] ? row["avg" + year].toFixed(2) + '%' : '';
                                return (
                                    <>
                                        <td className={cellClasses}>{firstVal}</td>
                                        <td className={cellClasses}>{secondVal}</td>
                                        <td></td>
                                    </>
                                )
                            })}
                        </tr>
                    )
                }
            })
        }
    }

    const buildNSCHBCRows = () => {
        let allRows = []
        let rows = pnlRows(props.naicsCode);
        let year = props.year

        if (rows) {
            grossReceiptsVals = DentistDoctorPNLVals(rows, calcs?.[props.naicsCode]?.['avg'], [year], grossReceiptsRow)
            rows.forEach((row) => {
                let rowValues = DentistDoctorPNLVals(rows, calcs?.[props.naicsCode]?.['avg'], [year], row)
                allRows.push({ ...row, ...rowValues })
            })

            return allRows.map((row, i) => {
                let rowStyle = { ...row.style }
                if (row.topline) {
                    rowStyle['borderTop'] = '1px solid #000000'
                }

                if (row.emptyRow) {
                    return (
                        <tr>
                            <td className="industry-copy-cell"></td>
                            <td className=''></td>
                            <td className='common-size-cell'></td>
                            <td className='space-cell'></td>
                            <td></td>
                            <td className='common-size-cell'></td>
                        </tr>
                    )
                } else if (row.header) {
                    return (
                        <tr key={Math.random(20)} style={rowStyle}>
                            <td className="industry-copy-cell" style={{ 'fontWeight': 'bold', 'textAlign': 'left' }}>{row.copyWithPadding}</td>
                            <td className=''></td>
                            <td className='common-size-cell'></td>
                            <td className='space-cell'></td>
                            <td></td>
                            <td className='common-size-cell'></td>
                        </tr>
                    )
                } else {
                    let avgVal = row["avgVal" + year] ? parseMoneyNoDollar(row["avgVal" + year]) : '0';
                    let csVal = row["avg" + year] ? row["avg" + year].toFixed(2) + '%' : '0.00%';
                    let fteVal = row["fteVal" + year] ? parseMoneyNoDollar(row["fteVal" + year]) : '0';
                    let fteAvgVal = row["fteAvgVal" + year] ? row["fteAvgVal" + year].toFixed(2) + '%' : '0.00%';

                    return (
                        <tr key={Math.random(20)} style={rowStyle}>
                            <td className="industry-copy-cell" style={{ 'fontWeight': 'bold', 'textAlign': 'left' }}>{row.copyWithPadding}</td>
                            <td className=''>{avgVal}</td>
                            <td className='common-size-cell'>{csVal}</td>
                            <td className='space-cell'></td>
                            <td>{fteVal}</td>
                            <td className='common-size-cell'>{fteAvgVal}</td>
                        </tr>
                    )
                }
            })
        }
    }


    const renderYearHeaderColumns = (years) => {
        let yearsRow = [];

        years.forEach((y, i) => {
            let cellClasses = 'common-size-cell ';

            if (i % 2 === 0) {
                cellClasses += 'money-table-cell';
            }

            yearsRow.push(
                <React.Fragment key={Math.random(i)}>
                    <td className={cellClasses} colSpan='2'>{y}</td>
                    <td className='space-cell'></td>
                </React.Fragment>
            )
        })

        return (
            <thead>
                <tr key={Math.random(20)}>
                    <td className="industry-copy-cell"></td>
                    {yearsRow}
                </tr>
            </thead>
        )
    }

    const buildNumOfCompaniesRow = () => {
        return (
            <tr key={`number-of-companies-${props.page}`} id={`${props.chart}-report-row-${props.page}`} >
                <td className="industry-copy-cell">Number of Companies</td>
                {props.yearRange.map((year, ii) => {
                    let backgroundStyle = '';
                    if (calcs['docs_avg']) {
                        let numOfCompanies = calcs['docs_avg']['number_of_companies'][year] || 0

                        if (ii % 2 === 0) {
                            backgroundStyle = 'money-table-cell';
                        }

                        return (
                            <React.Fragment key={Math.random(80)}>
                                <td key={`first-${ii}`} className={backgroundStyle}></td>
                                <td key={ii} className={backgroundStyle}>
                                    {`n = ${numOfCompanies}`}
                                </td>
                                <td></td>
                            </React.Fragment>
                        )
                    } else {
                        return null
                    }
                })}
            </tr>
        )
    }

    const buildNSCHBCHeader = () => {
        let totalNumOfDocs = 0
        if (props.filters.dataset === 'NSCHBC w/Employee Data') {
            totalNumOfDocs = calcs?.[props.naicsCode]?.['avg']?.['total_fte']?.[props.year] ? calcs?.[props.naicsCode]?.['avg']?.['total_fte']?.[props.year].toFixed(2) : 0;
        }
        const numOfCompanies = calcs?.[props.naicsCode]?.['avg']?.['number_of_companies']?.[props.year]

        return (
            <thead>
                <tr style={{ 'borderTop': '1px solid', 'borderLeft': '1px solid', 'borderRight': '1px solid' }}>
                    <td colSpan='6' style={{ 'fontSize': '14px' }}>{`${props.naicsCode} - ${props.naicsName}`}</td>
                </tr>
                <tr style={{ 'borderLeft': '1px solid', 'borderRight': '1px solid' }}>
                    <td style={{ 'textAlign': 'left' }}>{`Year: ${props.year}`}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{ 'textAlign': 'right' }}># FTE Drs:</td>
                    <td style={{ 'textAlign': 'right' }}>{totalNumOfDocs}</td>
                </tr>
                <tr style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid', 'borderRight': '1px solid' }}>
                    <td colSpan='4' style={{ 'textAlign': 'left' }}>{`Filters: Revenue - ${props.filters.revenue_band}, Region - ${props.filters.region}`}</td>
                    <td style={{ 'textAlign': 'right' }}># Practices:</td>
                    <td style={{ 'textAlign': 'right' }}>{numOfCompanies}</td>
                </tr>
                <tr style={{ 'height': '12px' }}></tr>
                <tr style={{ 'height': '12px' }}></tr>
                <tr style={{ 'height': '12px' }}></tr>
                <tr key={Math.random(20)}>
                    <td className='industry-copy-cell'></td>
                    <td className=''>Per Practice</td>
                    <td className='common-size-cell'>Avg %</td>
                    <td className='space-cell'></td>
                    <td>Per FTE Doctor</td>
                    <td className='common-size-cell'>Avg %</td>
                </tr>
            </thead>
        )
    }

    const buildNSCHBCNumOfCompaniesRow = () => {
        if (props.filters.dataset === 'NSCHBC') {
            const numberOfCompanies = calcs?.[props.naicsCode]?.['avg']?.['number_of_companies']?.[props.year]
            const numberOfFTECompanies = calcs?.[props.naicsCode]?.['fte_number_of_companies']

            return (
                <>
                    <tr>
                        <td className="industry-copy-cell"></td>
                        <td className=''></td>
                        <td className='common-size-cell'></td>
                        <td className='space-cell'></td>
                        <td></td>
                        <td className='common-size-cell'></td>
                    </tr>
                    <tr>
                        <td className="industry-copy-cell">Number of Practices</td>
                        <td className=''>{`n = ${numberOfCompanies}`}</td>
                        <td className='common-size-cell'></td>
                        <td className='space-cell'></td>
                        <td></td>
                        <td className='common-size-cell'></td>
                    </tr>
                    <tr>
                        <td className="industry-copy-cell"></td>
                        <td className=''></td>
                        <td className='common-size-cell'></td>
                        <td className='space-cell'></td>
                        <td></td>
                        <td className='common-size-cell'></td>
                    </tr>
                    <tr>
                        <td className="industry-copy-cell">Number of Practices with FTE</td>
                        <td className=''>{`n = ${numberOfFTECompanies}`}</td>
                        <td className='common-size-cell'></td>
                        <td className='space-cell'></td>
                        <td></td>
                        <td className='common-size-cell'></td>
                    </tr>
                </>
            )
        }
    }

    const buildReport = () => {
        if (props.report === 'nschbc-employee-data') {
            return (
                <div className='nschbc-pdf-portrait'>
                    <div className='nschbc-page-table-section'>
                        <table id='new-annual-table-naics_focused' style={{ whiteSpace: 'pre' }} className='industry-money-table' >
                            {buildNSCHBCHeader()}
                            <tbody>
                                {buildNSCHBCRows()}
                                {buildNSCHBCNumOfCompaniesRow()}
                            </tbody>
                        </table>
                        <p className='nschbc-doctor-asterisk-note'>*The sub-accounts might not add up to total account if details are not provided.</p> 
                    </div>
                    <div className='nschbc-page-footer'>
                        <span>{`${props.year} Data - Final Report`}</span>
                        <span className='page-span'>{`Page ${props.pageNumber}`}</span>
                        <span></span>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <div className='monthly-forecast-landscape report-card monthly-sheet'>
                        <div style={{ 'paddingTop': '10px', 'paddingLeft': '5px' }}>
                            <h1 className='report-table-title hide-not-on-print'>Doctor P&L</h1>
                            <div className='pdf-table-div industry-table-container'>
                                <table id='new-annual-table-naics_focused' style={{ whiteSpace: 'pre' }} className='industry-money-table' >
                                    {renderYearHeaderColumns(props.yearRange)}
                                    <tbody>
                                        {buildRows()}
                                        {buildNumOfCompaniesRow()}
                                    </tbody>
                                </table>
                            </div>
                            <p className='pdf-disclaimer-text'>{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return buildReport();
}

export default IndustryDoctorsPNL